module.exports = __webpack_public_path__ + "static/media/fondo3.1a74ac02.jpeg";